import { MenuList as Component } from "../../components/organisms/MenuList";
import { USER_ROLE } from "../../utils/constants";
import { AuthContext } from "../../hooks/useAuthentication";
import { use } from "react";

type Props = {
  onCreatePrescriptionClick: () => void;
};
export const MenuList = ({ onCreatePrescriptionClick }: Props) => {
  const { auth } = use(AuthContext);
  return (
    <Component
      onCreatePrescriptionClick={onCreatePrescriptionClick}
      isAdminMenuVisible={auth.userRole === USER_ROLE.CS_USER}
    />
  );
};
